export default __webpack_public_path__ + "static/media/client40.69963a2e.png";